import React, { useContext } from "react";

import { LinkHandler } from "@/components/common/LinkHandler";
import SearchContext from "@/context/SearchContext";
import { ContentfulProduct } from "@/types/common";
import { setCookie } from "@/utils/cookies";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";

import styles from "./ProductList.module.scss";
import ResultCard from "./ResultCard";

interface ProductListProps {
  products: ContentfulProduct[];
}

/**
 * Renders a list of product cards with navigation and analytics tracking
 */
const ProductList: React.FC<ProductListProps> = ({ products }) => {
  const { searchState, search, closeSearchDropdown } = useContext(SearchContext);
  // const navigate = useNavigation();

  return (
    <div className={styles.products}>
      {products.map((product, index) => (
        <div
          key={`${product.sku}-${index}`}
          className={cn(styles.productWrapper, index === products.length - 1 && styles.lastItem)}
        >
          <LinkHandler
            path={product?.slug || product?.urlPath || ""}
            onClick={() => {
              // e.preventDefault(); // Uncomment if you want to prevent default navigation
              GA4.onSearchClicked({
                name: "Search",
                search_term: search,
                destination: product?.urlPath,
                location: "navigation",
                state: searchState,
                text: product.title,
                type: "Link",
                index: "Products",
                eventType: "click",
                queryID: product?.queryID,
                objectID: product?.objectID,
              });

              setCookie("queryID", product?.queryID || "");
              closeSearchDropdown?.(false);
              // navigate(product?.slug || product?.urlPath || "");
            }}
          >
            <ResultCard key={product.sku} data={product} />
          </LinkHandler>
        </div>
      ))}
    </div>
  );
};

export default ProductList;
